import React from "react";
import clsx from "clsx";
import format from "date-fns/format";
import parseISO from "date-fns/parseISO";
import utcToZonedTime from "date-fns-tz/utcToZonedTime";
import BuildIcon from "@material-ui/icons/Build";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";
import { parseWorkOrderStatus } from "utils/enum-parser";
import { getPersonFullName } from "utils/person";
import useStyles from "./styles";

interface IProps {
  selectedWorkOrder: racehorse360.IWorkOrder;
  isEditable?: boolean;
}

const WorkOrderDetailContent = React.memo((props: IProps) => {
  const { selectedWorkOrder, isEditable } = props;
  const classes = useStyles();

  return selectedWorkOrder ? (
    <div
      className={clsx(classes.tableContent, {
        [classes.tableContentNoPadding]: !isEditable
      })}
    >
      <div className={classes.tableRow}>
        <span className={classes.tableCell}>Status</span>
        <span className={clsx(classes.tableCell, classes.rightCell)}>
          <BuildIcon
            className={clsx(
              classes.wrench,
              classes[`status-${selectedWorkOrder.status}`]
            )}
          />
          {parseWorkOrderStatus(selectedWorkOrder.status)}
        </span>
      </div>

      <div className={classes.tableRow}>
        <span className={classes.tableCell}>Order Type</span>
        <span className={clsx(classes.tableCell, classes.rightCell)}>
          {selectedWorkOrder.workOrderType.name}
        </span>
      </div>

      <div className={classes.tableRow}>
        <span className={classes.tableCell}>Assigned To</span>
        <span
          className={clsx(
            classes.tableCell,
            classes.rightCell,
            classes.cursive
          )}
        >
          {selectedWorkOrder.assignedUser
            ? getPersonFullName(selectedWorkOrder.assignedUser)
            : "Pending Assignment"}
        </span>
      </div>

      <div className={clsx(classes.tableRow, classes.column)}>
        <span className={clsx(classes.tableCell, classes.shrinkLabelCell)}>
          Notes
        </span>
        <span className={clsx(classes.tableCell, classes.notesText)}>
          No notes provided
        </span>
      </div>

      <div className={classes.dividerRow} />

      <div className={classes.tableRow}>
        <span className={classes.tableCell}>Track</span>
        <span
          className={clsx(
            classes.tableCell,
            classes.rightCell,
            classes.capitalize
          )}
        >
          {selectedWorkOrder.facility.name.toLowerCase()}
        </span>
      </div>

      <div className={classes.tableRow}>
        <span className={classes.tableCell}>Opened</span>
        <span className={clsx(classes.tableCell, classes.rightCell)}>
          {format(
            utcToZonedTime(
              parseISO(selectedWorkOrder.createdOn),
              selectedWorkOrder.facility.timezone
            ),
            "M/d/yy"
          )}
        </span>
      </div>

      <div className={classes.tableRow}>
        <span className={classes.tableCell}>Closed</span>
        <span className={clsx(classes.tableCell, classes.rightCell)}>
          {selectedWorkOrder.closedOn
            ? format(
                utcToZonedTime(
                  parseISO(selectedWorkOrder.closedOn),
                  selectedWorkOrder.facility.timezone
                ),
                "M/d/yy"
              )
            : "-"}
        </span>
      </div>

      <div className={classes.tableRow}>
        <span className={classes.tableCell}>ID #</span>
        <span className={clsx(classes.tableCell, classes.rightCell)}>
          {selectedWorkOrder.customerFacingId}
        </span>
      </div>

      <div className={classes.tableRow}>
        <span className={classes.tableCell}>Barn Number</span>
        <span className={clsx(classes.tableCell, classes.rightCell)}>
          {selectedWorkOrder.barn?.name || "-"}
        </span>
      </div>

      <div className={classes.tableRow}>
        <span className={classes.tableCell}>Stall Number</span>
        <span className={clsx(classes.tableCell, classes.rightCell)}>
          {selectedWorkOrder.stallNumber || "-"}
        </span>
      </div>

      <div className={clsx(classes.tableRow, classes.column)}>
        <span className={clsx(classes.tableCell, classes.shrinkLabelCell)}>
          Issue Description
        </span>
        <span className={clsx(classes.tableCell, classes.descriptionText)}>
          {selectedWorkOrder.description}
        </span>
      </div>
    </div>
  ) : (
    <></>
  );
});

export default WorkOrderDetailContent;
